/** A projeção fiscal só informa; a decisão continua na central do PCP. */
export interface AlertaCancelamentoFiscal {
  readonly rotulo: string;
  readonly mensagem: string;
  readonly destino: string;
}

export function apresentarAlertaCancelamento(ativo: boolean): AlertaCancelamentoFiscal | null {
  return ativo
    ? {
        rotulo: 'Cancelamento fiscal pendente',
        mensagem: 'A produção não foi pausada automaticamente. O PCP decide os próximos passos na central de recebimentos.',
        destino: '/pcp/recebimentos?aba=pendencias',
      }
    : null;
}
